import styled from 'styled-components';

import { Color, FontWeight } from '../../../../theme';

export const Container = styled.div``;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  background-color: ${Color.white};
  & + & {
    margin-top: 2px;
  }
`;

export const TableCell = styled.div`
  padding: 22px;
  color: ${Color.darkGrey};
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  letter-spacing: 0;
  line-height: 18px;
  flex: 1;
  &:last-of-type {
    flex: 2;
    font-weight: ${FontWeight.Light};
  }
`;
